<template>
<div class="chapter">
<div class="inner_page">
<p style="font-size: small; font-weight: bold; page-break-before: always; text-align: center; text-indent: 0">DEDICATION</p>
<p class="section-break">––––––––</p><div class="decoration-scene-break"><div class="decoration-scene-break-inner"><img alt="image" class="decoration-scene-break" src="d2d_images/scene_break.png"/></div></div>
<p style="text-align: center; text-indent: 0">This is dedicated to all girls and women who are bold enough to be true to themselves.</p>
<p style="font-size: small; font-weight: bold; page-break-before: always; text-align: center; text-indent: 0">ACKNOWLEDGEMENTS</p>
<p class="section-break">––––––––</p><div class="decoration-scene-break"><div class="decoration-scene-break-inner"><img alt="image" class="decoration-scene-break" src="d2d_images/scene_break.png"/></div></div>
<p style="text-align: center; text-indent: 0">This is for the Amazing Angels in Rachel Angel’s Royal Readers Group who are great with their enthusiasm, passion, and support for me, my books, and projects.  Thank You!</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// c002.vue?118a584a